import { apiAxios } from '/@/modules/core/app/helpers/AxiosHelper';
import { BaseResource } from '/@/modules/core/app/resources/BaseResource';
import Logger from '/@/modules/core/app/helpers/Logger';

export class GenericEntityResource extends BaseResource {
  /**
   * @var {string}
   */
  route;

  /**
   * @var {BaseModel}
   */
  model;

  /**
   * @param {string} route
   * @param {BaseModel} model
   */
  constructor(route, model) {
    super();

    this.route = route;
    this.model = model;

    if (!this.model) {
      Logger.log(`Model must be set for "${this.route}"`, Logger.LEVEL_ERROR);
    }
  }

  /**
   * @param params
   * @param headers
   * @returns {Promise<*>}
   */
  async getItems(params = {}, headers = {}) {
    return super.getData(this.route, this.model, params, headers);
  }

  /**
   * @param id
   * @param params
   * @param headers
   * @returns {Promise<*>}
   */
  async getItem(id, params = {}, headers = {}) {
    return super.getData(`${this.route}/${id}`, this.model, params, headers);
  }

  /**
   * @param params
   * @param model
   * @returns {Promise<*>}
   */
  async getTotal(params = {}, model = null) {
    return super.getData(`${this.route}/total`, model ?? this.model, params);
  }

  /**
   * @param data
   * @param {?int} id
   * @param config
   * @returns {Promise<*>}
   */
  async saveItem(data, id, config = {}) {
    return id
      ? apiAxios.put(`${this.route}/${id}`, data, config)
      : apiAxios.post(`${this.route}`, data, config);
  }

  /**
   * @param data
   * @param id
   * @param config
   * @returns {Promise<*>}
   */
  async saveFile(data, id, config = {}) {
    const route = id ? `${this.route}/${id}` : this.route;
    return apiAxios.post(route, data, config);
  }

  /**
   * @param id
   * @returns {Promise<*>}
   */
  async copyItem(id) {
    return super.getData(`${this.route}/copy/${id}`, this.model);
  }

  /**
   * @param id
   * @returns {Promise<*>}
   */
  async deleteItem(id) {
    return apiAxios.delete(`${this.route}/${id}`);
  }
}
